import { render, staticRenderFns } from "./faultReporting.vue?vue&type=template&id=3545b4f5&scoped=true&"
import script from "./faultReporting.vue?vue&type=script&lang=js&"
export * from "./faultReporting.vue?vue&type=script&lang=js&"
import style0 from "./faultReporting.vue?vue&type=style&index=0&id=3545b4f5&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3545b4f5",
  null
  
)

export default component.exports